import Vue from "vue";
import Toast from "vue-toastification";

import "vue-toastification/dist/index.css";

const options = {
  // You can set your default options here
};


Vue.use(Toast, options);

export default Vue.$toast;